(function () {
  'use strict';
  if (window.__vmsTvlMcp) return;
  window.__vmsTvlMcp = true;
  var REG = window.VMSPageTools = window.VMSPageTools || { version: 1, tools: [] };
  if (!REG.register) {
    REG.register = function (tool) {
      if (!tool || typeof tool.name !== 'string') return;
      var idx = -1;
      for (var i = 0; i < REG.tools.length; i++) { if (REG.tools[i].name === tool.name) { idx = i; break; } }
      if (idx >= 0) REG.tools[idx] = tool; else REG.tools.push(tool);
      try { document.dispatchEvent(new CustomEvent('vms:page-tools-changed')); } catch (e) {}
    };
    REG.unregister = function (name) {
      var before = REG.tools.length;
      REG.tools = REG.tools.filter(function (t) { return t.name !== name; });
      if (REG.tools.length !== before) { try { document.dispatchEvent(new CustomEvent('vms:page-tools-changed')); } catch (e) {} }
    };
    REG.list = function () { return REG.tools.slice(); };
  }

  var CANON = ['75x75', '100x100', '100x200', '200x100', '200x200', '200x300', '200x400', '300x200', '300x300', '300x400', '400x200', '400x300', '400x400', '400x600', '600x200', '600x400', '800x400'];
  var COMPACT = ['tv_id', 'manufacturer', 'model_number', 'model_norm', 'screen_size_in', 'lookup_status'];
  var DEFAULT_RANGE = [10, 90];
  var MAX_ALIAS_ROWS = 8;
  var MAX_BYTES = 7900;

  function bytes(s) { try { return unescape(encodeURIComponent(s)).length; } catch (e) { return s.length; } }

  function textResult(payload) { return { content: [{ type: 'text', text: JSON.stringify(payload) }] }; }

  function sid() {
    var S = window.VMSSavedTv, T = window.VMSTvLookup, s = S && typeof S.sid === 'function' ? S.sid() : (T && typeof T.sid === 'function' ? T.sid() : '');
    return /^[0-9a-f]{16}$/.test(s || '') ? '&sid=' + s : '';
  }

  function endpoint() {
    var el = document.querySelector('[data-vms-tvl]');
    return (el && el.getAttribute('data-endpoint')) || '/apps/toolkit/tv-lookup';
  }

  function sizeRange() {
    var p = window.VMSTvcmPage;
    if (p && Array.isArray(p.sizes) && p.sizes.length) {
      var a = p.sizes.filter(function (n) { return typeof n === 'number' && isFinite(n); });
      if (a.length) return [Math.min.apply(null, a), Math.max.apply(null, a)];
    }
    return DEFAULT_RANGE;
  }

  function isWhole(n) { return typeof n === 'number' && isFinite(n) && Math.floor(n) === n; }

  function findMountsInput(row, out) {
    var f = {};
    var s = row.screen_size_in;
    if (typeof s === 'number' && isFinite(s)) {
      var r = Math.round(s), range = sizeRange();
      if (r >= range[0] && r <= range[1]) f.screen_size_in = r;
    }
    var w = row.vesa_width_mm, h = row.vesa_height_mm;
    if (isWhole(w) && isWhole(h) && CANON.indexOf(w + 'x' + h) !== -1) f.vesa = w + 'x' + h;
    else out.vesa_in_finder = false;
    return f;
  }

  var SOURCE_KEYS = ['source_url', 'source_kind', 'source_checked', 'source_note'];

  function strip(r) {
    if (!r || typeof r !== 'object') return r;
    var c = {};
    for (var k in r) { if (Object.prototype.hasOwnProperty.call(r, k) && SOURCE_KEYS.indexOf(k) === -1) c[k] = r[k]; }
    return c;
  }

  function shape(body) {
    var rows = Array.isArray(body.rows) ? body.rows : [];
    var out = {};
    for (var k in body) { if (Object.prototype.hasOwnProperty.call(body, k) && k !== 'rows' && k !== 'report_endpoint' && k !== 'report_kinds') out[k] = body[k]; }
    var m = body.match;
    if (m === 'suggestion') {
      out.rows = rows.map(function (r) { var c = {}; COMPACT.forEach(function (key) { c[key] = r[key] === undefined ? null : r[key]; }); return c; });
      out.rows_compact = true;
      out.find_mounts_input = null;
      return out;
    }
    if (m === 'alias' && rows.length > MAX_ALIAS_ROWS) {
      out.rows = rows.slice(0, MAX_ALIAS_ROWS).map(strip);
      out.rows_truncated = true;
    } else {
      out.rows = rows.map(strip);
    }
    var single = m === 'exact' || m === 'merged' || (m === 'alias' && rows.length === 1);
    out.find_mounts_input = single && rows[0] && rows[0].lookup_status === 'vesa_known' ? findMountsInput(rows[0], out) : null;
    if (m === 'alias') {
      while (out.rows.length > 1 && bytes(JSON.stringify(out)) > MAX_BYTES) {
        out.rows.pop();
        out.rows_truncated = true;
      }
    }
    return out;
  }

  function none(query) {
    return { catalog_version: null, query: query, query_norm: null, match: 'none', rows: [], find_mounts_input: null };
  }

  function execute(args) {
    try {
      var a = args && typeof args === 'object' ? args : {};
      var model = typeof a.model === 'string' ? a.model.trim() : '';
      var limit = parseInt(a.limit, 10);
      if (!isFinite(limit)) limit = 5;
      limit = Math.max(1, Math.min(5, limit));
      if (model.length < 1 || model.length > 64) return Promise.resolve(textResult(none(model.slice(0, 64))));
      var url = endpoint();
      url += (url.indexOf('?') === -1 ? '?' : '&') + 'q=' + encodeURIComponent(model) + '&limit=' + limit + sid();
      var ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
      var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, 8000) : null;
      return fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin', signal: ctrl ? ctrl.signal : undefined })
        .then(function (res) {
          if (res.status === 400) return textResult(none(model));
          if (!res.ok) return textResult({ error: 'lookup_unavailable' });
          return res.json().then(function (body) { return textResult(shape(body || {})); });
        })
        .catch(function () { return textResult({ error: 'lookup_unavailable' }); })
        .then(function (r) { if (timer) clearTimeout(timer); return r; });
    } catch (e) {
      return Promise.resolve(textResult({ error: 'lookup_unavailable' }));
    }
  }

  var tool = {
    name: 'vms-lookup-tv',
    description: 'Look up a TV by the model number on the label on its back and return its VESA hole pattern, hole-to-edge offsets with their trust tier and verify level, panel dimensions and weight without stand, screw size, and a lookup status. Use it whenever a customer names a TV model on this page. Units are mm, kg and inches as named. Always show an offset with its tier and verify level; never derive, centre or copy one. A suggestion result lists different models, not the customer\'s TV: name them and ask which is theirs. On lookup_unavailable, ask for the VESA pattern from the TV\'s manual instead.',
    readOnlyHint: true,
    annotations: { readOnlyHint: true, idempotentHint: true, openWorldHint: false },
    inputSchema: {
      type: 'object',
      properties: {
        model: { type: 'string', minLength: 1, maxLength: 64, description: 'The TV model number as printed on the label on the back of the TV, for example UN65DU8000. Spacing and punctuation are ignored.' },
        limit: { type: 'integer', minimum: 1, maximum: 5, default: 5, description: 'Optional. The most rows to return, 1 to 5.' }
      },
      required: ['model']
    },
    execute: execute
  };

  REG.register(tool);

  var attached = typeof WeakSet !== 'undefined' ? new WeakSet() : null;
  function attach(mc) {
    if (!mc || typeof mc.registerTool !== 'function') return 0;
    if (attached && attached.has(mc)) return 0;
    try {
      mc.registerTool({ name: tool.name, description: tool.description, inputSchema: tool.inputSchema, annotations: tool.annotations, readOnlyHint: true, execute: tool.execute });
      if (attached) attached.add(mc);
      return 1;
    } catch (e) { return 0; }
  }

  window.VMSTvLookupMCP = { tools: [tool], attach: attach };

  var done = false;
  function currentMC() {
    var d = window.document, n = window.navigator;
    return (d && d.modelContext) || (n && n.modelContext) || null;
  }
  function tryAttach() {
    if (done) return true;
    if (window.top !== window.self || window.isSecureContext === false) { done = true; return true; }
    var mc = currentMC();
    if (!mc || typeof mc.registerTool !== 'function') return false;
    attach(mc);
    done = true;
    return true;
  }
  try {
    if (!tryAttach()) {
      var again = function () { tryAttach(); };
      document.addEventListener('DOMContentLoaded', again);
      window.addEventListener('load', again);
      var waits = [500, 500, 1000, 2000, 4000, 8000, 15000];
      var step = function (i) {
        if (done || i >= waits.length) return;
        setTimeout(function () { if (!tryAttach()) step(i + 1); }, waits[i]);
      };
      step(0);
    }
  } catch (e) {}
})();
